module.exports = __webpack_public_path__ + "c4d4aa709f71556f5bc68b5b2457f07a.jpg";